export const DEFAULT_START = "09:00";
export const DEFAULT_END = "09:30";

/**
 * @param {string} lastEndTime - Previous slot end time (HH:mm)
 * @param {number} durationMinutes - Slot duration: 30 or 60 (default: 30)
 * @returns {{start: string, end: string}} - Next slot start/end times
 */
export const generateNextSlot = (lastEndTime, durationMinutes = 30) => {
  const duration = durationMinutes === 60 ? 60 : 30;

  const [hour, min] = lastEndTime.split(":").map(Number);

  // Don't allow slots after 11:30 PM
  if (hour === 23 && min >= 30) {
    return null;
  }

  const start = new Date(0, 0, 0, hour, min);
  const end = new Date(0, 0, 0, hour, min + duration);

  const format = (date) => date.toTimeString().slice(0, 5);

  // Prevent rollover to next day
  if (end.getDate() !== start.getDate()) {
    return null;
  }

  return {
    start: format(start),
    end: format(end),
  };
};

export const timeOptions = Array.from({ length: 24 * 2 }).map((_, i) => {
  const totalMinutes = i * 30;
  const h = String(Math.floor(totalMinutes / 60)).padStart(2, "0");
  const m = String(totalMinutes % 60).padStart(2, "0");
  return `${h}:${m}`;
});

export const getDurationInMinutes = (start, end) => {
  if (!start || !end) return 0;

  const [sh, sm] = start.split(":").map(Number);
  const [eh, em] = end.split(":").map(Number);

  const startMinutes = sh * 60 + sm;
  const endMinutes = eh * 60 + em;

  return endMinutes - startMinutes;
};

/**
 * Adds a specified number of minutes to a time string (HH:mm format).
 * @param {string} time - Time string (HH:mm)
 * @param {number} minutes - Minutes to add
 * @returns {string} - New time string (HH:mm)
 */
export const addMinutesToTime = (time, minutes) => {
  if (!time) return "";
  const [h, m] = time.split(":").map(Number);

  // Using Date to automatically handle hour overflow/underflow
  const date = new Date(1970, 0, 1, h, m + minutes);
  const hh = String(date.getHours()).padStart(2, "0");
  const mm = String(date.getMinutes()).padStart(2, "0");

  return `${hh}:${mm}`;
};